var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2008 10.9V41.98C30.8266 42.017 30.449 41.9621 30.1008 41.82L17.9008 37.26C17.55 37.1276 17.1747 37.073 16.8008 37.1V6.02C17.175 5.983 17.5526 6.03792 17.9008 6.18L30.1008 10.74C30.4515 10.8724 30.8269 10.927 31.2008 10.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.74 6.27953C16.0692 6.11387 16.4316 6.02498 16.8 6.01953V37.0995C16.4319 37.1073 16.07 37.1961 15.74 37.3595L8.90005 40.7995C8.59408 40.9537 8.25362 41.0267 7.91133 41.0115C7.56904 40.9963 7.23639 40.8935 6.94527 40.7128C6.65416 40.5321 6.41435 40.2796 6.24884 39.9796C6.08332 39.6796 5.99766 39.3422 6.00005 38.9995V13.6395C6.00044 12.8954 6.20842 12.1661 6.60061 11.5336C6.99279 10.9012 7.55362 10.3907 8.22005 10.0595L15.74 6.27953Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.9992 9.0003V34.3603C41.9988 35.1045 41.7908 35.8338 41.3987 36.4662C41.0065 37.0986 40.4456 37.6091 39.7792 37.9403L32.2592 41.7203C31.9301 41.886 31.5677 41.9748 31.1992 41.9803V10.9003C31.5674 10.8925 31.9293 10.8037 32.2592 10.6403L39.0992 7.2003C39.4052 7.0461 39.7456 6.9731 40.0879 6.9883C40.4302 7.00349 40.7629 7.10636 41.054 7.28705C41.3451 7.46774 41.5849 7.72019 41.7504 8.02018C41.9159 8.32018 42.0016 8.65768 41.9992 9.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.929c312cede38f7ef8dde0c34448c458.svg";
export { ForwardRef as ReactComponent };